export default "__VITE_PUBLIC_ASSET__b79ff459__"